/**
 * Diagrams API
 * Functions for fetching diagrams
 */

import { api } from "./api";
import type { ApiResponse } from "@learn-me/types";

export interface SectionDiagram {
  id: string;
  sectionId: string;
  type: string;
  title: string;
  mermaidCode: string;
  description: string | null;
  position: number;
  status: "GENERATING" | "COMPLETED" | "FAILED" | "NEEDS_REVIEW";
  createdAt: string;
}

export const diagramsApi = {
  /**
   * Get all diagrams for a section
   */
  async getSectionDiagrams(sectionId: string): Promise<SectionDiagram[]> {
    const response = await api.get<SectionDiagram[]>(
      `/diagrams/section/${sectionId}`,
    );
    // Backend returns array directly (not wrapped in ApiResponse)
    return response.data || [];
  },

  /**
   * Get diagram by ID
   */
  async getDiagram(diagramId: string): Promise<SectionDiagram> {
    const response = await api.get<ApiResponse<SectionDiagram>>(
      `/diagrams/${diagramId}`,
    );
    return response.data.data!;
  },

  /**
   * Delete a diagram (admin only - server enforces auth)
   */
  async deleteDiagram(diagramId: string): Promise<void> {
    await api.delete(`/diagrams/${diagramId}`);
  },
};
